import { fg } from '@atlassian/jira-feature-gating';

// copy from `dev-tooling/packages/deployment-orchestrator-jira-fe/src/constants.ts`
const SEMANTIC_VERSION_REGEX: RegExp =
	/^(?<major>\d+)\.(?<minor>\d+)\.(?<patch>\d+)-(?<gitCommitHash>[0-9a-f]+)$/;

export const isOverridingFragments = (): boolean => {
	const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
	if (fg('magma-remove-mrjf-in-src-packages')) {
		return buildKey ? !SEMANTIC_VERSION_REGEX.test(buildKey) : false;
	}

	const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
	return buildKey ? re.test(buildKey) : false;
};
